import { Stack } from '@mui/material';

import { DocumentCard } from '@/components/DocumentCard';
import { IconButton } from '@/components/form/baseInputs/Button/IconButton';
import { Trash01Icon } from '@/components/icons/Trash01Icon';

interface PasswordProtectedFile {
  id: string;
  name: string;
}

interface PasswordProtectedFilesListProps {
  protectedFiles: PasswordProtectedFile[];
  onDeleteFile: (fileId: string) => void;
}

export function PasswordProtectedFilesList({
  protectedFiles,
  onDeleteFile,
}: PasswordProtectedFilesListProps) {
  if (protectedFiles.length === 0) {
    return null;
  }

  return (
    <>
      {protectedFiles.map((protectedFile) => (
        <DocumentCard
          key={protectedFile.id}
          filename={protectedFile.name}
          status="error"
          message="This file is password protected and cannot be uploaded, please remove password protection from file and upload again."
          controls={
            <Stack direction="row" spacing={1} alignItems="center">
              <IconButton
                icon={Trash01Icon}
                ariaLabel="Delete file"
                size="sm"
                variant="transparent"
                onClick={() => onDeleteFile(protectedFile.id)}
              />
            </Stack>
          }
        />
      ))}
    </>
  );
}
